/* eslint-disable one-var */
import VueMultiselectExtended from './multiselect';

const updateModelValueEmit = 'update:modelValue';

let defaultIsoCurrencySymbol = '', defaultPreferredCurrencySymbol = '';

function initFormattedPriceComponent(isoCurrencySymbol, preferredCurrencySymbol) {
    defaultIsoCurrencySymbol = isoCurrencySymbol;
    defaultPreferredCurrencySymbol = preferredCurrencySymbol;
};

const editableCurrencyPrice = {
    template: '#editable-currency-price',
    props: {
        modelValue: {
            default: 0,
        },
        fieldName: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        autocomplete: {
            type: String,
            default: 'off',
        },
        placeholder: {
            type: String,
            default: '',
        },
        allowEmpty: {
            type: Boolean,
            default: true,
        },
        addon: {
            type: String,
            default: '',
        },
    },
    emits: [updateModelValueEmit],
    data() {
        return {
            price: this.modelValue,
        };
    },
    watch: {
        value(val) {
            this.price = val;
        },
        price() {
            this.$emit(updateModelValueEmit, this.price);
        },
    },
    methods: {
        computeCurrencySymbol(preferredCurrency) {
            return preferredCurrency;
        },
        roundPrice(price) {
            return _roundPrice(price);
        },
    },
};

const priceMultyselect = {
    template: '#price-multiselect-template',
    components: {
        Multiselect: VueMultiselectExtended,
    },
    props: {
        modelValue: {
            required: true,
        },
        options: {
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
    },
    emits: [updateModelValueEmit],
    data() {
        return {
            innerValue: this.modelValue,
        };
    },
    methods: {
        computeCurrencySymbol(preferredCurrency) {
            return preferredCurrency;
        },
    },
    watch: {
        innerValue(val) {
            this.$emit(updateModelValueEmit, val);
        },
    },
};

const priceMultyselectTemp = {
    template: '#price-multiselect-temp',
    components: {
        Multiselect: VueMultiselectExtended,
    },
    props: {
        modelValue: {
            required: true,
        },
        options: {
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
        allowEmpty: {
            type: Boolean,
            default: true,
        },
        preselectFirst: Boolean,
        preselectLast: Boolean,
        zeroLabel: Boolean,
    },
    emits: [updateModelValueEmit],
    data() {
        return {
            innerValue: this.modelValue,
            isSelectOpen: false,
        };
    },
    methods: {
        getCurrencySymbol(preferredCurrency) {
            return preferredCurrency;
        },
    },
    watch: {
        innerValue(val) {
            this.$emit(updateModelValueEmit, val);
        },
    },
};

const multipleCurrenciesPrice = {
    template: '#multiple-currencies-price',
    props: {
        modelValue: {
            required: true,
        },
        currencies: {
            required: true,
        },
        selectedCurrency: {
            required: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
        addonText: {
            type: String,
        },
        maxLength: {
            type: Number,
            default: 10,
        },

    },
    emits: [updateModelValueEmit, 'update:selectedCurrency'],
    data() {
        return {
            price: this.modelValue,
            currency: this.selectedCurrency,
            isMultiselectActive: false,
        };
    },
    computed: {
        currencySymbol() {
            return this.currency;
        },
    },
    watch: {
        price(val) {
            this.$emit(updateModelValueEmit, val);
        },
        currency(val) {
            this.$emit('update:selectedCurrency', val);
        },
    },
    methods: {
        roundPrice(price) {
            return _roundPrice(price);
        },
    },
};

const formattedPrice = {
    template: `#formatted-price`,
    props: {
        price: {required: true},
        formatterType: {default: 'long'},
        currency: {default: defaultIsoCurrencySymbol},
        currencySymbolClass: {default: 'sup_size-s'},
        pricePeriodShortText:  {default: ''},
        supForCurrency: {default: true},
        showSign: {default: false},
        replaceNbsp: {default: false},
        metricAddon: {default: null},
    },
    computed: {
        formattedPrice() {
            const currencySymbol = defaultPreferredCurrencySymbol;
            const price = this.$filters['formatPrice'](this.price, this.formatterType, this.currency);
            let result = price.split(currencySymbol).join(this.formattedCurrency(currencySymbol));

            if (this.replaceNbsp) {
                result = result.replace(/\u00a0/g, ' ');
            }

            const priceNumber = parseFloat(this.price);
            if (priceNumber > 0 && this.showSign) {
                result = `+ ${result}`;
            }

            return result;
        },

    },

    methods: {
        formattedCurrency(currencySymbol) {
            let result = currencySymbol;

            if (this.metricAddon) {
                result = `${result}${this.metricAddon}`;
            }

            if (this.supForCurrency) {
                const trimmedPeriod = this.pricePeriodShortText ? this.pricePeriodShortText.replace(/ /g,'') : '';
                result = `<sup class="${this.currencySymbolClass}">${result}${trimmedPeriod}</sup>`;
            }

            return result;
        },
    },
};

function initCurrencyPriceComponents(app) {
    app.component('editable-currency-price', editableCurrencyPrice);

    app.component('price-multiselect', priceMultyselect);

    app.component('price-multiselect-temp', priceMultyselectTemp);

    app.component('multiple-currencies-price', multipleCurrenciesPrice);

    app.component('formatted-price', formattedPrice);
};

function _roundPrice(price) {
    return price !== null && price !== '' ? Math.trunc(price) : null;
};

export {
    initFormattedPriceComponent,
    initCurrencyPriceComponents,
    updateModelValueEmit,
};
